import fetch from 'cross-fetch';
import { encodeParameters } from '@utils/http-util';
import { Logger } from "@utils/logger";

export const pollForAsyncStatus = (apSessionId: string, asi: string, contextPath: string): Promise<any> => {
    const queryParams = {
        url: `${contextPath}/gateway/async-ui/status`,
        apSessionId,
        asi,
        cacheBuster: new Date().getUTCMilliseconds()
    };

    const { url, ...params } = queryParams;
    const finalUrl = `${url}?${encodeParameters(params)}&cb=${new Date().getTime()}`;

    const request = {
        method: "GET"
    };

    Logger.info(`Polling for async status:  ${finalUrl}`);
    return fetch(finalUrl, request);
};
